import { render, staticRenderFns } from "./ScheduleStart.vue?vue&type=template&id=8853a522&"
import script from "./ScheduleStart.vue?vue&type=script&lang=js&"
export * from "./ScheduleStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports